<template>
  <div class="resident-warpper">
    <div class="bg-white" v-if="member">
      <table class="detail-table">
        <tr>
          <td colspan="5" class="active">
            <div class="flex align-center justify-between">
              <div></div>
              志愿者队长明细表
              <el-button
                size="small"
                type="warning"
                @click="exportWuyeguanjiaDetail"
              >导出
              </el-button>
            </div>
          </td>
        </tr>
        <tr>
          <td>姓名：{{ member.name }}</td>
          <td>手机号：{{ member.username }}</td>
          <td>完成的服务项数：{{ member.service_num }}</td>
          <td>积分：{{ member.integral }}
            <el-button type="primary" icon="el-icon-edit" class="margin-left" round @click="editSCore(1)"
                       size="medium"></el-button>
          </td>
        </tr>
<!--        <tr>-->

<!--          <td>金暖宝：{{ member.jinnuanbao }}-->
<!--            <el-button type="primary" icon="el-icon-edit" class="margin-left" round @click="editSCore(2)"-->
<!--                       size="medium"></el-button>-->
<!--          </td>-->
<!--          <td>银暖宝：{{ member.yinnuanbao }}-->
<!--            <el-button type="primary" icon="el-icon-edit" class="margin-left" round @click="editSCore(3)"-->
<!--                       size="medium"></el-button>-->
<!--          </td>-->
<!--        </tr>-->
      </table>

      <el-table
        :data="residentList"
        header-row-class-name="table-header"
        row-class-name="table-row"
        alig="center"
        border
        style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
        <el-table-column label="操作内容" prop="content"></el-table-column>
        <el-table-column label="时间" prop="create_time"></el-table-column>
        <el-table-column label="积分" prop="integral"></el-table-column>
<!--        <el-table-column label="金暖宝" prop="jinnuanbao"></el-table-column>-->
<!--        <el-table-column label="银暖宝" prop="yinnuanbao"></el-table-column>-->
        <el-table-column label="说明" prop="reason">
          <template slot-scope="scope">
            <div class="table-operate" v-if="Number(scope.row.type) !== 4">
              {{ scope.row.reason }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                v-if="Number(scope.row.type) === 4"
                size="small"
                type="primary"
                @click="detailItem(scope.row.id)"
              >查看
              </el-button>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="residentList.length > 0"
        class="page-all"
        background
        @current-change="getDetail"
        :current-page.sync="page"
        :page-size="limit"
        layout="prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>

    </div>
    <editaAdminScoreDialog
      :score="score"
      :type="type"
      :scoreDialog="scoreDialog"
      @cancelDialog="cancelDialog"
    />
    <serveMuneDialog
      :serverMune="serverMune"
      :serverMuneDialog="serverMuneDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import { exportWuyeguanjiaDetail, getWuyeguanjiaDetail} from "@/api/weilao";
import editaAdminScoreDialog from "@/views/pages/sndialog/editaAdminScoreDialog";
import serveMuneDialog from "@/views/pages/sndialog/serveMuneDialog";

export default {
  name: "server-pople-detail",
  data() {
    return {
      member: null,
      residentList: [],
      page: 1,
      limit: 10,
      total: 0,
      scoreDialog: false,
      score: 0,
      type: 0,
      serverMuneDialog: false,
      serverMune: 0,
    }
  },
  created() {
    this.$emit("setIndex", '/home/team-member', "双暖为老 / 志愿者队长详情", true);
    this.getDetail()
  },
  components: {
    editaAdminScoreDialog,serveMuneDialog
  },
  methods: {

    //  居民导出
    async exportWuyeguanjiaDetail(){
      let _state = await exportWuyeguanjiaDetail(
        this.$route.params.id
      )
      let blob = _state.data
      var downloadElement = document.createElement('a');
      var href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.setAttribute('download', this.member.name + '明细表.xls');
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放掉blob对象
    },


    detailItem(id) {
      this.serverMune = id
      this.serverMuneDialog = true
    },
    cancelDialog() {
      this.scoreDialog = false
      this.page = 1
      this.score = 0
      this.type = 0
      this.serverMuneDialog = false
      this.serverMune = 0
      this.getDetail()
    },
    //修改各类积分
    editSCore(num) {
      this.type = num
      this.score = num === 1 ? this.member.integral : num === 2 ? this.member.jinnuanbao : this.member.yinnuanbao
      this.scoreDialog = true
    },
    //  获取详情
    async getDetail() {
      let _data = await getWuyeguanjiaDetail(this.$route.params.id, this.page, this.limit)
      this.member = _data.data
      this.residentList = _data.data.integral_log
      this.total = _data.total_number
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.detail-table {
  width: 100%;
  border-top: 1px solid #c2ccd1;
  border-left: 1px solid #c2ccd1;

  td {
    border-bottom: 1px solid #c2ccd1;
    border-right: 1px solid #c2ccd1;
    padding: 20px;
    text-align: center;
    vertical-align: center;
    font-size: 16px;
    background: rgba(#f3b861, .5);
    //color: #fff;
  }
}
</style>
